
      <span class="a" id="span{{id}}" [innerHTML]="currentText"></span>
      <span class="b" *ngIf="showToggleButton" id="spanAnchor{{id}}" style="cursor: pointer;visibility:hidden">
          <a style="visibility:visible; color: #5d9cec !important;" class="c" id="a{{id}}" (click)="toggleView()">&nbsp;&nbsp;{{isCollapsed? bs.getResource('rbkey_SeeMrLBL'): (text.length <= this.maxLength)? '' :bs.getResource('rbkey_SeeLssLBL')}}</a>
      </span>